require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-what-is-the-cloud.json") })
        }
      }, "path---blog-what-is-the-cloud");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-what-is-the-cloud!./.cache/json/blog-what-is-the-cloud.json
// module id = 1140
// module chunks = 231608221292675